import { useUserStore } from '../store/userStore';
import { UserRole } from '../constants/roles';

export function useIsSuperAdmin(): boolean {
  const user = useUserStore((state) => state.user);
  return user?.role === UserRole.SUPERADMIN;
}
